import createReducer from 'utils/createReducer';
import {
  UPDATE_HARDWARE_PRODUCTS,
  UPDATE_HARDWARE_BASE_PRODUCTS,
  SET_HARDWARE_LOADING,
  SHOW_CREATE_HARDWARE_MODAL,
  SHOW_EDIT_HARDWARE_MODAL,
  SET_HARDWARE_EDITOR_LOADING,
  SET_HARDWARE_EDITOR_ERROR,
  SHOW_DELETE_HARDWARE_CONFIRMATION,
  SET_HARDWARE_DELETE_LOADING,
  HARDWARE_CATALOGUE_LOG_SET_SHOWN,
  HARDWARE_CATALOGUE_LOG_SET_DATA,
  HARDWARE_CATALOGUE_LOG_SET_IS_LOADING,
  HARDWARE_CATALOGUE_LOG_SET_ERRORS,
} from './actionTypes';

const initialState = {
  products: [],
  baseProducts: [],
  isLoading: false,
  editor: {
    isOpen: false,
    isEditMode: false,
    editingProduct: null,
    isLoading: false,
    errorMessage: null,
    errors: [],
  },
  deleteConfirmation: {
    isOpen: false,
    isLoading: false,
    productToDelete: null,
  },
  log: {
    shown: false,
    data: [],
    paging: { page: 1, size: 20, total: 0 },
    isLoading: false,
    errors: [],
  },
};

const updateHardwareProducts = (state, action) => ({
  ...state,
  products: action.payload,
});

const updateHardwareBaseProducts = (state, action) => ({
  ...state,
  baseProducts: action.payload,
});

const setHardwareLoading = (state, action) => ({
  ...state,
  isLoading: action.payload,
});

const showCreateHardwareModal = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isOpen: action.payload.shown,
    isEditMode: false,
    editingProduct: null,
    errorMessage: null,
    errors: [],
  },
});

const showEditHardwareModal = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isOpen: action.payload.shown,
    isEditMode: !!action.payload.shown,
    editingProduct: action.payload.productData,
    errorMessage: null,
    errors: [],
  },
});

const setHardwareEditorLoading = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    isLoading: action.payload,
  },
});

const setHardwareEditorError = (state, action) => ({
  ...state,
  editor: {
    ...state.editor,
    errorMessage: action.payload ? action.payload.message : null,
    errors: (action.payload && action.payload.errors) || [],
  },
});

const showDeleteHardwareConfirmation = (state, action) => ({
  ...state,
  deleteConfirmation: {
    ...state.deleteConfirmation,
    isOpen: action.payload.shown,
    productToDelete: action.payload.productData,
  },
});

const setHardwareDeleteLoading = (state, action) => ({
  ...state,
  deleteConfirmation: {
    ...state.deleteConfirmation,
    isLoading: action.payload,
  },
});

export default createReducer(initialState, {
  [UPDATE_HARDWARE_PRODUCTS]: updateHardwareProducts,
  [UPDATE_HARDWARE_BASE_PRODUCTS]: updateHardwareBaseProducts,
  [SET_HARDWARE_LOADING]: setHardwareLoading,
  [SHOW_CREATE_HARDWARE_MODAL]: showCreateHardwareModal,
  [SHOW_EDIT_HARDWARE_MODAL]: showEditHardwareModal,
  [SET_HARDWARE_EDITOR_LOADING]: setHardwareEditorLoading,
  [SET_HARDWARE_EDITOR_ERROR]: setHardwareEditorError,
  [SHOW_DELETE_HARDWARE_CONFIRMATION]: showDeleteHardwareConfirmation,
  [SET_HARDWARE_DELETE_LOADING]: setHardwareDeleteLoading,
  [HARDWARE_CATALOGUE_LOG_SET_SHOWN]: (draft, { payload }) => {
    draft.log.shown = payload.shown;
  },
  [HARDWARE_CATALOGUE_LOG_SET_DATA]: (draft, { payload }) => {
    draft.log.data = payload.data;
    draft.log.paging = payload.paging;
  },
  [HARDWARE_CATALOGUE_LOG_SET_IS_LOADING]: (draft, { payload }) => {
    draft.log.isLoading = payload.isLoading;
  },
  [HARDWARE_CATALOGUE_LOG_SET_ERRORS]: (draft, { payload }) => {
    draft.log.errors = payload.errors;
  },
});
